import React, { Component } from 'react'
import log from '../../../helpers/logger'
import { auth, getCurrentUser } from '../../../helpers/auth'

export default class DashboardPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errorMsg: null,
      currentUser: null,
      isLoading: true,
      dataList: []
    };

  }

  componentWillMount() {
    log.debug('componentWillMount')
  }
  async componentDidMount(){
    log.debug('componentDidMount')
    let user = await getCurrentUser();
    this.setState({currentUser: user})
    log.debug(user)
    log.debug('all data is loaded.')
    this.setState({isLoading: false})
  }

  render () {

    let content;

    if (this.state.isLoading) {
      content = <div>Loading...</div>;
    } else {
      content =
      <div>
        <h3>Dashboard</h3>
        <p>Welcome {this.state.currentUser.email} .</p>
      </div>
    }


    return (
      <div>
          {content}
      </div>
    )
  }




}



// WEBPACK FOOTER //
// ./src/components/pages/DashboardPage/DashboardPage.js